import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useDealStatusContext } from './contexts/DealStatusContext';
import { IMarketPagePayload } from './types';
import Market from '@/creditflowresearch/domain/Market';
import Segment from '@/creditflowresearch/domain/Segment';
import Product from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';

export interface IUseMarketPageFiltersProps {
  pageFilters?: IMarketPagePayload | null,
}

export const useMarketPageFilters = ({
  pageFilters,
}: IUseMarketPageFiltersProps) => {
  const { selectedStatuses } = useDealStatusContext();
  const router = useRouter();

  const buildFilters = useCallback(() => {
    const baseFilters = pageFilters?.filters || {
      includedProductIds: [],
      includedRegionIds: [],
      includedMarketIds: [],
      includedSegmentIds: [],
    };
    const { markets, segments, products, regions } = router.query;

    return {
      ...baseFilters,
      includedStatusGroups: selectedStatuses,
      includedProductIds: Product.getIds(products) || baseFilters.includedProductIds,
      includedRegionIds: Region.getIds(regions) || baseFilters.includedRegionIds,
      includedMarketIds: Market.getIds(markets) || baseFilters.includedMarketIds,
      includedSegmentIds: Segment.getIds(segments) || baseFilters.includedSegmentIds,
    };
  }, [pageFilters, selectedStatuses, router.query]);

  const buildPaging = useCallback(() => {
    return pageFilters?.paging || { page: 1, perPage: 10 };
  }, [pageFilters]);

  return {
    buildFilters,
    buildPaging,
    selectedStatuses,
  };
};
